var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6863 11.0282L22.1862 3.52805C21.7677 3.10969 21.0893 3.10981 20.671 3.5283C20.4701 3.7292 20.3573 4.00154 20.3572 4.28562V7.49996H12.8571C12.2653 7.49996 11.7856 7.97966 11.7856 8.57142C11.7856 9.16319 12.2653 9.64289 12.8571 9.64289H21.4287C22.0205 9.64289 22.5002 9.16319 22.5002 8.57142V6.87203L27.4138 11.7857L22.5002 16.6994V15C22.5002 14.4083 22.0205 13.9286 21.4287 13.9286H9.64276V10.7142C9.64263 10.1225 9.16281 9.64289 8.57111 9.64301C8.28709 9.64308 8.01469 9.75589 7.81379 9.95673L0.313712 17.4569C-0.104591 17.8753 -0.104591 18.5535 0.313712 18.9719L7.81385 26.472C8.01475 26.673 8.28721 26.7859 8.57136 26.786C8.71217 26.7864 8.85173 26.7587 8.98169 26.7046C9.38197 26.5386 9.64289 26.1479 9.64276 25.7145V22.5002H17.1429C17.7347 22.5002 18.2144 22.0205 18.2144 21.4287C18.2144 20.8369 17.7347 20.3572 17.1429 20.3572H8.57136C7.97959 20.3572 7.49989 20.8369 7.49989 21.4287V23.128L2.58622 18.2144L7.49989 13.3007V15C7.49989 15.5918 7.97959 16.0715 8.57136 16.0715H20.3572V19.2858C20.3574 19.8776 20.8372 20.3572 21.4289 20.3571C21.7129 20.357 21.9853 20.2442 22.1862 20.0433L29.6863 12.5432C30.1046 12.1248 30.1046 11.4466 29.6863 11.0282Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIc);
export default __webpack_public_path__ + "static/media/transfer-ic.acef90600aef44771ad6b60abafefe63.svg";
export { ForwardRef as ReactComponent };